import { useState, useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import calenderIcon from "../../assets/icons/calendar-icon.svg";
import disabledCalenderIcon from "../../assets/icons/disabled-calender-icon.svg";
import PropTypes from "prop-types";

const CustomCalendarIcon = ({ disabled }) => (
  <img src={disabled ? disabledCalenderIcon : calenderIcon} alt="calendar" style={{ width: 20, height: 20 }} />
);

const BasicDatePicker = ({ props, setFieldValue, handleChangeEvent }) => {
  const today = dayjs();
  let minDate = today.subtract(100, "year");
  let maxDate = today.subtract(18, "year");

  if (props?.controlId === "sample_collection_date") {
    minDate = today.subtract(15, "day");
    maxDate = today;
  }

  const [internalValue, setInternalValue] = useState(
    props?.value ? dayjs(props.value) : null,
  );

  useEffect(() => {
    setInternalValue(props?.value ? dayjs(props.value) : null);
  }, [props?.value]);

  const handleClear = () => {
    setInternalValue(null);
    const e = { target: { name: props?.name, value: "" } };
    if (props?.handleChange) props?.handleChange?.(e, setFieldValue);
    handleChangeEvent(e);
  };

  const handleChange = (newValue) => {
    // MUI passes null when the clear button is clicked
    if (newValue === null) {
      handleClear();
      return;
    }

    setInternalValue(newValue);

    if (!dayjs(newValue).isValid() || dayjs(newValue).year() < 1000) {
      return;
    }

    const e = {
      target: {
        name: props?.name,
        value: dayjs(newValue).format("YYYY-MM-DD"),
      },
    };

    if (props?.handleChange) {
      props?.handleChange?.(e, setFieldValue);
    }
    handleChangeEvent(e);
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={internalValue}
          minDate={minDate}
          maxDate={maxDate}
          format="DD/MM/YYYY"
          closeOnSelect={true}
          disabled={props?.disabled}
          onChange={handleChange}
          onClose={() => {
            props?.onBlur?.({
              target: { name: props?.name },
            });
          }}
          slots={{
            openPickerIcon: () => (
              <CustomCalendarIcon disabled={props?.disabled} />
            ),
          }}
          slotProps={{
            textField: {
              name: props?.name,
              id: props?.id,
              disabled: props?.disabled,
              placeholder: "dd/mm/yyyy",
              className: `${props?.className || ""} custom-date-input`,
              size: "small",
              fullWidth: true,
              sx: props?.disabled
                ? {
                  "& .MuiPickersOutlinedInput-root.Mui-disabled": {
                    backgroundColor: "#e9ecef",
                  },
                  "& .MuiPickersOutlinedInput-root.Mui-disabled input": {
                    color: "#6c757d",
                    WebkitTextFillColor: "#6c757d",
                  },
                }
                : {},
            },
            openPickerButton: {
              disableRipple: true,
              className: "calendar-icon-btn",
            },
            field: {
              shouldRespectLeadingZeros: true,
            },
            actionBar: {
              actions: ["clear"],
            },
          }}
          onError={() => { }}
        />
      </LocalizationProvider>

      {props?.error &&
        props?.name !== "sample_collection_date" &&
        props?.controlId !== "007" &&
        props?.controlId !== "dob-account" && (
          <div className="invalid-feedback d-block">{props?.error}</div>
        )}
    </>
  );
};

BasicDatePicker.propTypes = {
  props: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
      PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    error: PropTypes.string,
    className: PropTypes.string,
    controlId: PropTypes.string,
    handleChange: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  setFieldValue: PropTypes.func,
  handleChangeEvent: PropTypes.func.isRequired,
};

export default BasicDatePicker;
